import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyItFailedSection } from './components/WhyItFailedSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsItForSection } from './components/WhoIsItForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    document.title = 'Protocolo Anti-Inflamación 72h — Recupera tu ligereza en 3 días';
    const setMeta = (property: string, content: string) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    };
    setMeta('og:title', 'Protocolo Anti-Inflamación 72h');
    setMeta('og:description', 'El método específico para latinas en USA que elimina la retención de líquidos y la hinchazón abdominal sin pasar hambre ni vivir en el gimnasio.');
    setMeta('og:image', 'https://cdn.magicpatterns.com/uploads/u3h6xU6zEcqbpUAvD2WZDQ/Mockup_PTO_1_Anti-Desinflamacion_72H.png');
    setMeta('og:type', 'website');
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-gray-900 selection:bg-gold selection:text-forest" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <WhyItFailedSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <WhoIsItForSection data-id="element-6" />
      <HowItWorksSection data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <FinalOfferSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}